import { useCallback, useState } from 'react'
import type { useAgencyFlow } from './agency-flow.hook'

interface EdgePopoverState {
  isOpen: boolean
  edgeId: string | null
  label: string
  position: { x: number; y: number }
}

const initialEdgePopoverState: EdgePopoverState = {
  isOpen: false,
  edgeId: null,
  label: '',
  position: { x: 0, y: 0 },
}

export const useAgencyFlowEdgePopover = (agencyFlow: ReturnType<typeof useAgencyFlow>) => {
  const [edgePopoverState, setEdgePopoverState] =
    useState<EdgePopoverState>(initialEdgePopoverState)

  const openEdgePopover = useCallback(
    (edgeId: string, label: string, x: number, y: number): void => {
      setEdgePopoverState({ isOpen: true, edgeId, label, position: { x, y } })
    },
    []
  )

  const closeEdgePopover = useCallback((): void => setEdgePopoverState(initialEdgePopoverState), [])

  const handleEdgeLabelSave = useCallback(
    (label: string): void => {
      if (edgePopoverState.edgeId) agencyFlow.updateEdgeLabel(edgePopoverState.edgeId, label)
      setEdgePopoverState(initialEdgePopoverState)
    },
    [edgePopoverState.edgeId, agencyFlow]
  )

  const handleEdgePopoverOpenChange = useCallback((isOpen: boolean): void => {
    if (!isOpen) setEdgePopoverState(initialEdgePopoverState)
  }, [])

  return {
    edgePopoverState,
    openEdgePopover,
    closeEdgePopover,
    handleEdgeLabelSave,
    handleEdgePopoverOpenChange,
  }
}
